(function() {
  'use strict';

  angular.module('blocks.types', []);
})();
